var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shapeHome"},[_c('div',{staticClass:"angle",class:{red:_vm.color=='red',sye:_vm.color=='sye',qye:_vm.color=='qye'}}),_vm._v(" "),_c('span',{staticClass:"angletext"},[_vm._v(_vm._s(_vm.num))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e26af64","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shape.vue
// module id = 14
// module chunks = 0